<script setup>
const props = defineProps({
  company: {
    type: Object,
    required: true,
  },
  type: {
    type: String,
    required: true,
    validation: (val) =>
      ['personality', 'motivations', 'culture', 'cognitive'].includes(val),
  },
})

const { mapProfile } = useAssessmentMapper()

const image = computed(() => {
  switch (props.type) {
    case 'personality':
      return '/images/illustration-personality.svg'
    case 'motivations':
      return '/images/illustration-motivation.svg'
    case 'culture':
      return '/images/illustration-culture.svg'
    case 'cognitive':
      return '/images/illustration-cognitive.svg'
  }
})

const title = computed(() => {
  switch (props.type) {
    case 'personality':
      return 'Persoonlijkheid'
    case 'motivations':
      return 'Drijfveren'
    case 'culture':
      return 'Cultuur'
    case 'cognitive':
      return 'Cognitief'
  }
})

const ranking = computed(() => {
  const mappedProfile = mapProfile(props.company?.profile)
  switch (props.type) {
    case 'personality':
      return mappedProfile.topOperationalRoles
    case 'motivations':
      return mappedProfile.topMotivations
    case 'culture':
      return mappedProfile.topCultures
  }
})

const educationText = computed(() => {
  const education = props.company?.profile?.education
  if (!education) return ''
  if (education.min === education.max) {
    return `${education.min} niveau`
  }
  return `${education.min} tot ${education.max} niveau`
})
</script>

<template>
  <section
    class="flex flex-col items-center rounded border border-gray-200 bg-white px-6 py-8"
  >
    <h3 class="font-sans text-2xl font-semibold text-secondary">{{ title }}</h3>
    <img class="mt-8 h-30 w-30" :src="image" />

    <div v-if="type === 'cognitive'" class="mt-12">
      <p class="text-center text-lg text-gray-800">
        {{ company.name }} is op zoek naar mensen met
      </p>
      <p class="text-center text-lg font-semibold text-secondary">
        {{ educationText }}
      </p>
    </div>

    <div v-else class="mt-12 flex w-full flex-col">
      <ExpandableItem
        v-for="(item, index) in ranking"
        :key="index"
        theme="underlined"
      >
        <template #title>{{ item.label }}</template>
        <template #content>{{ item.description }}</template>
      </ExpandableItem>
    </div>
  </section>
</template>
